/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
var iconStyle = css({
  transform: 'rotate(-90deg)'
});
export default function SwitchIcon() {
  return jsx("span", {
    css: iconStyle
  }, jsx(RefreshIcon, {
    label: ""
  }));
}